/* jshint ignore:start */

/* jshint ignore:end */

(function ($) {

  if ($('#calendar_changed').length) {
    $(document).on('click', '#calendar_changed', function (e) {
      if ($('#calendar_changed').prop('checked')) {
        $("label.label__calendar_phone").html('Telefonnummer');
        $("input#calendar_phone").prop('required',true);
      } else {
        $("label.label__calendar_phone").html('Telefonnummer (optional)');
        $("input#calendar_phone").prop('required',false);
      }
    });
  }

  if ($('button.calendar_send').length) {
    $(document).on('click', 'button.calendar_send', function (e) {
        e.preventDefault();

        // All fields to check
        var fields = [
            'input.calendar_prename_new',
            'input.calendar_lastname',
            'input.calendar_street',
            'input.calendar_housenumber',
            'input.calendar_zip',
            'input.calendar_city'
        ];

        // Loop through and add/remove "invalid" class on click
        fields.forEach(function(selector) {
            var $field = $(selector);
            if (!$field.val()) {
                $field.addClass('invalid');
            } else {
                $field.removeClass('invalid');
            }
        });

        // If all have a value, submit
        if (
            $('input.calendar_prename_new').val() &&
            $('input.calendar_lastname').val() &&
            $('input.calendar_street').val() &&
            $('input.calendar_housenumber').val() &&
            $('input.calendar_zip').val() &&
            $('input.calendar_city').val()
        ) {
            // GTM
            var GTM_Data_forms = { "event": "formSubmit" };
            GTM_Data_forms.formName = "Ernährungsratgeber Order Form";
            GTM_Data_forms.formStep = "Form Submit";
            GTM_Data_forms.formStepNr = "2";
            GTM_Data_forms.formStepCount = "2";
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(GTM_Data_forms);
            console.log(GTM_Data_forms);

            setTimeout(function () {
                $('form#calendar_form').submit();
            }, 150);
        }
    });

    // Cleanup: remove validated class as soon as user types in the field
    var liveFields = [
        'input.calendar_prename_new',
        'input.calendar_lastname',
        'input.calendar_street',
        'input.calendar_housenumber',
        'input.calendar_zip',
        'input.calendar_city'
    ].join(',');

    $(document).on('input', liveFields, function () {
        if ($(this).val()) {
            $(this).removeClass('invalid');
        }
    });
}



})(jQuery);